import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import cn from 'classnames';
import { useState } from 'react';
import { IconUiClose } from '../../';
function AlertSimpleBase(_ref) {
  var className = _ref.className,
    allowClose = _ref.allowClose,
    icon = _ref.icon,
    closeDescription = _ref.closeDescription,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["className", "allowClose", "icon", "closeDescription", "children"]);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var handleClose = function handleClose() {
    setIsOpen(false);
  };
  if (!isOpen) {
    return null;
  }
  return jsx("div", _extends({
    className: cn('zenit', className)
  }, props, {
    sx: _objectSpread({}, styles.container)
  }), icon, children && jsx("span", {
    sx: styles.content
  }, children), allowClose && jsx("button", {
    "aria-label": closeDescription,
    onClick: handleClose,
    sx: styles.closeButton
  }, jsx(IconUiClose, {
    size: "xsmall"
  })));
}
var styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1,
    color: 'grey.8'
  },
  content: {
    fontSize: 1,
    marginLeft: 2,
    marginRight: 2,
    whiteSpace: 'nowrap'
  },
  closeButton: {
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    outline: 'none',
    padding: 0
  }
};
AlertSimpleBase.defaultProps = {
  closeDescription: 'Close',
  allowClose: false
};
export { AlertSimpleBase };